var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.test_case_report") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", { staticClass: "requestsList" }, [
              _c("div", { staticClass: "mt-0" }, [
                _c(
                  "div",
                  [
                    _c("TestCaseReportList", {
                      attrs: { type: _vm.TrackType, id: _vm.id },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }